module.exports = __webpack_public_path__ + "img/bg_dzp.a6f31e90.svg";